import {
  Activity,
  Parent,
  SearchFilters as SearchFiltersType
} from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";

import {
  getClassPageTitle,
  getDefaultPageDescription,
  getDefaultPageTitle,
  getParentPageDescription,
  getParentPageTitle,
  getSearchPageDescription,
  getSearchPageTitle
} from "../../shared/PageMetadata";

export function useClassPageTitle(
  activity: Pick<Activity, "age_max" | "age_min" | "isClub" | "title">
): string | null {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getClassPageTitle(t, activity);
}

export const useDefaultPageTitle = (): string => {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getDefaultPageTitle(t);
};

export const useDefaultPageDescription = () => {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getDefaultPageDescription(t);
};

export function useOnlineClassesPageTitle(): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return t("Affordable online classes for kids: academic, tutoring, and more");
}

export function useOnlineClassesPageDescription(): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return t(
    "Live online classes that make kids excited to learn. Try academic courses, virtual tutoring, fun clubs, and more. As low as $10 per class."
  );
}

export function useSearchPageTitle(filters: SearchFiltersType): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getSearchPageTitle(t, filters);
}

export function useSearchPageDescription(theme: string): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getSearchPageDescription(t, theme);
}

export function useParentPageTitle(parent: Pick<Parent, "publicName">): string {
  return getParentPageTitle(parent);
}

export function useParentPageDescription(
  parent: Pick<Parent, "publicName" | "introduction">
): string {
  const { t } = useTranslation("client\\hooks\\PageMetaDataHooks");
  return getParentPageDescription(t, parent);
}
